// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3ZZmB","header":"ReportDetails_header__2ocXQ","title":"ReportDetails_title__uQx0Q","left":"ReportDetails_left__PQJC7"};